<script>
  import _base from '../../_default/components/_base.vue'
  import {merge as _merge} from 'lodash'
  // import {Status as SocketStatus} from '../../../domain/leiloes/helpers/SocketStatus'
  // import * as Status from '../../../domain/leiloes/helpers/LoteStatus'
  // import {number_format as numberFormat} from '../../../utils/helpers/phpjs'
  import Service from '../../../domain/leiloes/services/pregao'
  import Comunicator from 'rogeriomenezes-comunicator'
  import moment from 'moment'

  export default {
    name: 'PregaoLanceV2',
    extends: _base,
    data () {
      return {
        isComConnected: 0,
        leilao: {},
        pregao: null,
        lote: {
          numero: 0,
          imagem: null,
          descricao: '-',
          valorInicial: 0.00,
          valorIncremento: 0.00,
          valorMinimo: 0.00,
          valorMeta: 0.00,
          lancePrincipal: null,
          status: null,
          comitente: {
            pessoa: {}
          },
          pregao: null,
          lances: []
        },
        isLoading: false,
        centerContentFolded: false,
        hasNovoLance: false,
        countDownTimer: 10
      }
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o leilão')
      Service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.isLoading = false
          this.leilao = response.data.leilao
          /* if (typeof this.leilao['timerPregao'] !== 'undefined') {
           this.$refs.painelLote.updateDefaultTimerPregao(this.leilao['timerPregao'])
           } */
          this.lote = response.data.lote
          this.pregao = response.data.pregao
          if (this.pregao !== null) {
            window.setTimeout(() => {
              this.centerContentFolded = true
              this.carregaPregao()
            }, 500)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
          window.responseError(response)
          console.log(response)
        })
    },
    computed: {
      filteredLances: function () {
        let data = this.lote.lances
        if (!Array.isArray(data)) {
          data = []
        }
        // Ordena pelo valor de forma decrescente
        data = data.slice().sort(function (a, b) {
          a = Number(a['valor'])
          b = Number(b['valor'])
          return (a === b ? 0 : a > b ? 1 : -1) * -1 // -1 = desc, 1 = asc
        })

        return data.slice(0, 5) // Somente os 5 últimos lances
      },
      lanceLocalidade: function () {
        return this.testHasProperty() ? this.filteredLances[0].arrematante.pessoa.essencial.cidade + ' - ' + this.filteredLances[0].arrematante.pessoa.essencial.uf : '-'
      },
      lanceData: function () {
        return this.testHasProperty() ? moment(this.filteredLances[0].data.date).format('L') + ' - ' + moment(this.filteredLances[0].data.date).format('LTS') : '-'
      },
      valor: function () {
        return this.testHasProperty() ? this.filteredLances[0].valor : 0
      },
      apelido: function () {
        return this.testHasProperty() ? this.filteredLances[0].arrematante.apelido : '-'
      }
    },
    mounted () {
      /* Realtime Comunicator */
      // this.wsChannel = 'pregao/' + this.$route.params.id
      this.comunicator = Comunicator.connect(process.env.WS_URL)
      this.comunicator.on('lance', this.onLance)
      this.comunicator.on('status', this.onStatus)
      this.comunicator.on('statusLeilao', this.onStatusLeilao)
      this.comunicator.on('tempo', this.onTempo)
      this.comunicator.on('mudaLote', this.onMudaLote)
      this.comunicator.on('lanceDeletado', this.onLanceDeletado)
      this.comunicator.on('alteracaoIncremento', this.onAlteracaoIncremento)
      this.comunicator.on('alteracaoTempo', this.onAlteracaoTempo)
      this.comunicator.on('comitenteDecisaoStatusLote', this.onComitenteDecisaoStatusLote)
      this.comunicator.on('com/connect', (env) => {
        this.isComConnected = 1
      })
      this.comunicator.on('com/disconnect', (env) => {
        this.isComConnected = 2
      })
      window.setTimeout(() => {
        if (this.isComConnected !== 1) {
          this.isComConnected = 2 // No connection alert
        }
      }, 4000)
      /* End */
      this._showMenu(false)
      this._showHeader(true)
      this._showFooter(false)
      this._menuFolded(false)
      this.$nextTick(() => {
        this.$root.$el.classList.add('full-height')
      })
    },
    destroyed () {
      console.log('Saindo da tela realtime')
      this.comunicator.close()
      this.$root.$el.classList.remove('full-height')
    },
    methods: {
      onLance: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        this.lote.lances.unshift(data.lote.lance)
        this.lote.lancePrincipal = this.filteredLances.length > 0 ? this.filteredLances.slice(0, 1).shift() : null
        this.remoteNovoLance({
          id: data.lote.id,
          status: data.lote.status,
          lancePrincipal: data.lote.lance
        }, data.lote.lance)
      },
      onStatus: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        delete this.lote.pregao
        _merge(this.lote, data.lote)
        // this.mountTimerCountdown()
      },
      onStatusLeilao: function (data) {
      },
      onTempo: function (data) {
      },
      onMudaLote: function (data) {
        if (!this.validateComunication(data)) {
          return
        }
        this.leilao = data.leilao
        this.pregao = data.pregao
        this.lote = data.lote
        this.$nextTick(() => {
          if (typeof this.leilao['timerPregao'] !== 'undefined') {
            // this.updateDefaultTimerPregao(this.leilao['timerPregao'])
            // this.mountTimerCountdown()
          }
        })
      },
      onLanceDeletado: function (data) {
        if (!(this.validateComunication(data) && this.validateComunicationLote(data))) {
          return
        }
        if (this.lote.lances.length === 0) {
          return
        }
        for (let i = 0, len = this.lote.lances.length; i < len; ++i) {
          if (this.lote.lances[i].id === data.lote.lance) {
            this.lote.lances.splice(i, 1)
            break
          }
        }
      },
      onAlteracaoIncremento: function (data) {
      },
      onAlteracaoTempo: function (data) {
      },
      onComitenteDecisaoStatusLote: function (data) {
        console.log(data) // TODO: Fazer notificação
      },
      validateComunication: function (event) {
        if (typeof event['leilao'] === 'undefined') {
          return false
        }
        if (typeof event['leilao']['id'] !== 'undefined') {
          return event['leilao']['id'] === this.leilao.id
        }
        return event['leilao'] === this.leilao.id
      },
      validateComunicationLote: function (event) {
        if (typeof event['lote'] === 'undefined') {
          return false
        }
        if (typeof event.lote['id'] === 'undefined') {
          if (event.lote === this.lote.id) {
            return true
          }
        } else {
          if (event.lote.id === this.lote.id) {
            return true
          }
        }
        return false
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      testHasProperty: function () {
        return this.filteredLances.length > 0
      },
      toggleKeyboard (v) {
        this.centerContentFolded = v
      },
      reajustaTimerPregao: function (newTimer) {
        this.leilao.timerPregao = this.countDownTimer = newTimer
        this.$nextTick(() => {
          this.mountTimerCountdown()
        })
        console.log('Reajustando timer do pregão')
      },
      carregaPregao: function () {
        let that = this
        Service.find(this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.isLoading = false
            this.leilao = response.data.leilao
            this.lote = response.data.lote
            this.pregao = response.data.pregao
            if (this.pregao !== null) {
              window.setTimeout(() => {
                this.centerContentFolded = true
                that.$nextTick(function () {
                  if (typeof that.leilao['timerPregao'] !== 'undefined') {
                    that.updateDefaultTimerPregao(that.leilao['timerPregao'])
                    that.mountTimerCountdown()
                  }
                })
              }, 500)
            }
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            // window.alert('Erro ao carregar o pregão. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            window.responseError(response)
            console.log(response)
          })
      },
      reset: function () {
        this.countDownTimer = 10
      },
      updateDefaultTimerPregao: function (seconds) {
        this.countDownTimer = parseInt(seconds)
      },
      mountTimerCountdown: function () {
        // nothing to do
      },
      remoteNovoLance: function (lote, lance) {
        this.hasNovoLance = true
        this.$nextTick(function () {
          window.setTimeout(() => {
            this.hasNovoLance = false
          }, 100)
        })

        _merge(this.lote, lote)
        // this.updateLancePrincipal()
        // this.lote.lances.unshift(lance)
        this.mountTimerCountdown()
      },
      calcPercentTimer: function (percent) {
        let downTimer = this.timerPregao
        return (downTimer * (percent / 100))
      }
    },
    components: {}
  }
</script>

<template>
  <div class="h-full">
    <div class="acompanhamento-lance2 h-full"
         :class="{'isLoading': isLoading, isOnline: apelido !== 'PLATEIA' && apelido !== '-'}">

      <div class="box valorAtual" :class="{novoLance: hasNovoLance}">{{ valor | moeda }}</div>
      <div class="tipoLance" v-if="apelido !== '-'"><span v-if="apelido !== 'PLATEIA'">Online</span><span v-else>Presencial</span></div>
      <div class="tipoLance" v-else><span>-</span></div>

      <div class="box-lance">
        <div class="lance">
          <div class="apelido">{{ apelido }}</div>
          <div class="localidade">{{ lanceLocalidade }}</div>
        </div>
        <!--<div class="cronometro" :class="{'lance-danger': countDownTimer <= calcPercentTimer(30)}">
          {{ timerPregaoFormatado }}
        </div>-->
      </div>

    </div>
  </div>
</template>

<style lang="scss" src="./assets/scss/default.scss"></style>



// WEBPACK FOOTER //
// Main.vue?60d2cd68